/**
 * Value for the data-mdlfy-cms attribute that makes a database text value editable
 * in the preview: `<table>:<row id>:<column>`, using the real column name.
 */
export const cms = (table: string, id: string, column: string): string => `${table}:${id}:${column}`
